import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from 'components/Icon';
import { noop } from 'helpers/GlobalHelper';

const PlayButton = ({
  playButtonClick = () => {},
  render = false,
  theme = {},
  thinIcon = true,
}) => {
  if (!render) return null;
  let icon = 'play-button';
  let viewBox = null;
  if (thinIcon) {
    icon = 'play-button-thin';
    viewBox = '1 1 36 36';
  }
  return (
    <div className={theme.playButtonOverlay}>
      <div
        aria-label="play button"
        className={classNames([theme.playButton])}
        onMouseDown={e => (e.button === 1 ? playButtonClick() : noop)}
        onClick={playButtonClick}
      >
        <Icon icon={icon} color="white" size="full" viewBox={viewBox} />
      </div>
    </div>
  );
};

PlayButton.propTypes = {
  playButtonClick: PropTypes.func,
  render: PropTypes.bool,
  theme: PropTypes.shape({}),
  thinIcon: PropTypes.bool,
};

export default PlayButton;
